<div class="w-full h-full border-8 border-white bg-gray-200" [class.animate-pulse]="pulse"></div>